import { LookalikeSourcesViewProps } from 'types/components/audiences';
import LookalikeSourcesAudiencesView from './LookalikeSourceAudiences.View';

const LookalikeSourcesAudiences = (props: LookalikeSourcesViewProps) => (
  <LookalikeSourcesAudiencesView {...props} />
);

export default LookalikeSourcesAudiences;
